import { render } from "./Ebook.vue?vue&type=template&id=62b80198"
import script from "./Ebook.vue?vue&type=script&lang=js"
export * from "./Ebook.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__